import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ITaskFinder } from './ITaskFinder';
import { FindModel } from "./FindModel";

interface IFindResultModel {
    count: number;
}

class TaskFinder implements ITaskFinder {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    getCount(model: FindModel): Promise<number> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/tasks/get-count',
            method: HttpMethod.POST
        }, model);

        return new Promise<number>((resolve, reject) => {
            this.manager
                .get<IFindResultModel>(request)
                .then((res) => {
                    resolve((res as IFindResultModel).count);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(0);
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<ITaskFinder>('ITaskFinder', (frm) => {
        return new TaskFinder(frm);
    });
}